<template>
  <div>
    <div class="text-right text-nowrap">
      <b-link
        href="javascript:void(0)"
        class="request-link"
        :disabled="!requestDataAvailable"
        @click="toggleModal">
        {...} API Request
      </b-link>
    </div>

    <!-- modal dialog -->
    <b-modal-custom
      title="API Request Details"
      :modal-class.sync="$options.data.themeClass"
      v-model="modalDisplay"
      :ok-only="true"
      ok-title="Close"
      @ok="toggleModal">

      <div v-if="availableSections.length > 1" class="mb-3">
        <b-nav pills align="center">
          <b-nav-item v-for="sectionName in availableSections"
                      :key="sectionName"
                      :active="sectionName === currentSectionName"
                      @click="setCurrentSection(sectionName)">
            {{ getSectionNameDisplay(sectionName) }}
          </b-nav-item>
        </b-nav>
      </div>

      <b-form>
        <!-- request method -->
        <b-form-group
          v-if="fieldsDisplay.method"
          description="Request method"
          label="Method"
          label-for="method"
          :label-cols="2">
          <b-form-input
            id="method"
            type="text"
            autocomplete="Method"
            readonly
            v-model.trim="methodDisplay"/>
        </b-form-group>

        <!-- request url -->
        <b-form-group
          v-if="fieldsDisplay.url"
          description="Request URL"
          label="URL"
          label-for="url"
          :label-cols="2">
          <b-form-input
            id="url"
            type="text"
            autocomplete="URL"
            readonly
            v-model.trim="urlDisplay"/>
        </b-form-group>

        <!-- request headers data -->
        <b-form-group
          v-if="fieldsDisplay.headers"
          description="Request headers"
          label="Headers"
          label-for="headers"
          :label-cols="2">

          <b-form-textarea
            id="headers"
            type="text"
            autocomplete="Headers"
            :rows="4"
            readonly
            v-model.trim="headersDisplay" />
          </b-form-group>

        <!-- request body data -->
        <b-form-group
          v-if="fieldsDisplay.params"
          description="Request URL parameters"
          label="Parameters"
          label-for="data"
          :label-cols="2">

          <b-form-textarea
            id="params"
            type="text"
            autocomplete="Params"
            :rows="5"
            readonly
            v-model.trim="paramsDisplay" />
          </b-form-group>

        <!-- request body data -->
        <b-form-group
          v-if="fieldsDisplay.data"
          description="Request body data (JSON)"
          label="Body"
          label-for="data"
          :label-cols="2">

          <b-form-textarea
            id="data"
            type="text"
            autocomplete="Data"
            :rows="9"
            readonly
            v-model.trim="dataDisplay" />
          </b-form-group>
      </b-form>
    </b-modal-custom>

    <!-- end of modal dialog -->
  </div>
</template>

<script>

  import debounce from 'lodash-es/debounce'
  import { mapGetters } from 'vuex'
  import BModalCustom from '@/base_components/BModalCustom'

  // settings
  const debounceDelay = 50;


  export default {
    name: 'api-request-details',
    components: {
      BModalCustom,
    },

    props: {
      apiRequestData: {
        type: Object,
        default: () => ({
          // it's possible to have a few active requests at the same page
          emptySection: {
            method: 'GET',
            url: '',
            headers: {},
            params: {},
            data: {},
          },
        })
      },
    },

    data() {
      return {
        modalDisplay: false,
        currentSectionName: 'emptySection',
        apiRequestIsPerforming: false,

        fieldsDisplay: {
          method: true,
          url: true,
          headers: false,
          params: false,
          data: true,
        },
      };
    },

    methods: {
      toggleModal() {
        this.modalDisplay = !this.modalDisplay;
      },

      setCurrentSection(sectionName) {
        this.currentSectionName = sectionName;
      },

      getSectionNameDisplay(sectionName) {
        if(!this.apiRequestData[sectionName].url) {
          return this.currentSectionName;
        }

        let urlParts = this.apiRequestData[sectionName].url.split('/');
        return urlParts[urlParts.length - 1];
      },
    },

    computed: {
      ...mapGetters(
        'api', [
          'getActiveRequestsCount',
        ]
      ),

      availableSections() {
        return Object.keys(this.apiRequestData).filter((sectionName) => {
          return this.apiRequestData[sectionName] && this.apiRequestData[sectionName].url;
        });
      },

      currentSectionData() {
        return this.apiRequestData[this.currentSectionName] || {};
      },

      requestDataAvailable() {
        return this.availableSections.length && !this.apiRequestIsPerforming;
      },

      urlDisplay() {
        return this.currentSectionData.url || '--';
      },

      methodDisplay() {
        return this.currentSectionData.method || '--';
      },

      headersDisplay() {
        return JSON.stringify(this.currentSectionData.headers || {}, null, 4);
      },

      paramsDisplay() {
        return JSON.stringify(this.currentSectionData.params || {}, null, 4);
      },

      dataDisplay() {
        return JSON.stringify(this.currentSectionData.data || {}, null, 4);
      },
    },

    watch: {
      availableSections(sections) {
        if(sections && sections.length) {
          this.currentSectionName = sections[0];
        }
      },

      getActiveRequestsCount: debounce(function (newValue) {
        this.apiRequestIsPerforming = !!newValue;
      }, debounceDelay),
    },
  }
</script>
